import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';
import moment from 'moment';

export default class Event extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get description() {
    return get(this, '_opis.value', '');
  }

  get datetime() {
    return get(this, '_data.value');
  }

  get dateDay() {
    return this.datetime ? moment(this.datetime).format('DD') : '';
  }

  get dateMonth() {
    return this.datetime ? moment(this.datetime).format('MM') : '';
  }

  get dateYear() {
    return this.datetime ? moment(this.datetime).format('YYYY') : '';
  }
}



// WEBPACK FOOTER //
// ./src/models/Event.js